/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_As_Of_LabelInputs */

const en_cargos_as_of_label = /** @type {(inputs: Cargos_As_Of_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As of date`)
};

const es_cargos_as_of_label = /** @type {(inputs: Cargos_As_Of_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fecha de`)
};

/**
* | output |
* | --- |
* | "As of date" |
*
* @param {Cargos_As_Of_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_as_of_label = /** @type {((inputs?: Cargos_As_Of_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_As_Of_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_as_of_label(inputs)
	return es_cargos_as_of_label(inputs)
});